import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';
import { v1 as uuidv1 } from 'uuid';

export interface SaveProtocol {
  bffVersion: string;
  correlationId: string;
}

export const INITIAL_STATE_SAVE_PROTOCOL: SaveProtocol = {
  bffVersion: null,
  correlationId: uuidv1(),
};

export function saveProtocolReducer(
  sectionState: SaveProtocol = INITIAL_STATE_SAVE_PROTOCOL,
  action: AnyAction,
): SaveProtocol {
  switch (action.type) {
    case GlobalActions.BFF_VERSION_UPDATED: {
      return {
        ...sectionState,
        bffVersion: action.payload,
      };
    }
    default:
      return sectionState;
  }
}
